import { render, staticRenderFns } from "./ComicCardMarvelApi.vue?vue&type=template&id=e4d40c32&scoped=true&"
import script from "./ComicCardMarvelApi.vue?vue&type=script&lang=js&"
export * from "./ComicCardMarvelApi.vue?vue&type=script&lang=js&"
import style0 from "./ComicCardMarvelApi.vue?vue&type=style&index=0&id=e4d40c32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d40c32",
  null
  
)

export default component.exports